import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";
import Context from "./Context/Context";

// Lazy-load react-hot-toast to keep initial bundle smaller
const LazyToaster = React.lazy(() =>
  import("react-hot-toast").then((mod) => ({ default: mod.Toaster })),
);

// Defer AOS initialization to after first paint
const initAOS = async () => {
  const AOS = (await import("aos")).default;
  await import("aos/dist/aos.css");
  AOS.init({
    once: true, // Only animate once for better performance
    duration: 600,
    easing: "ease-out",
  });
};

// Initialize AOS after page is interactive
if ("requestIdleCallback" in window) {
  requestIdleCallback(() => initAOS());
} else {
  setTimeout(initAOS, 100);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Context>
      <App />
      <React.Suspense fallback={null}>
        <LazyToaster />
      </React.Suspense>
    </Context>
  </React.StrictMode>,
);
